import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { makeObservable, observable, runInAction } from "mobx";
class TcfDataCategory {
    data;
    store;
    constructor(data, store){
        makeObservable(this);
        runInAction(()=>{
            this.data = data;
        });
        this.store = store;
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], TcfDataCategory.prototype, "data", void 0);
export { TcfDataCategory };
